import React, { Component } from 'react'
import './BlogCard.css';
import {BlogCards} from "../../data"
import {Link} from "react-router-dom"
import { BsArrowRight } from "@react-icons/all-files/bs/BsArrowRight";

export default class BlogCardImage extends Component {
    render() {
        return (
            <>
            <div className="card-row"> 
                {
                BlogCards.map(item =>(
                    <div className={`card-column ${item.className} `}>
                        <img src={item.blogThumbnail} alt="img"/>
                        <div className="card-date">
                            {item.address} 
                        </div>
                        <div className="card-header">
                            {item.text1}
                        </div>
                        <div className="card-para">
                            {item.text2}
                        </div>
                        <Link to="/blogdetails">
                        <div className="card-read-more">
                            {item.text3}
                             &nbsp; &nbsp;
                             <div className="readmore-icon">
                             <BsArrowRight />
                             </div>
                        </div>
                        </Link>

                    </div>
                ))
                }
                
            </div>
        </>
        )
    }
}








